import { CategoryColor } from '@models/TagCategory.model';
import styled from 'styled-components';

export const CustomOption = styled.div`
  color: #161a30;
  cursor: pointer;
  background-color: transparent;
  font-size: 12px;
  display: flex;
  align-items: center;
`;

interface ICircle {
  color: CategoryColor;
}

export const Circle = styled.div<ICircle>`
  width: 16px;
  height: 16px;
  border-radius: 8px;
  margin-right: 8px;
  background-color: ${({ color }) => color || '#edeff4'};
`;
